import { useEffect, useState } from "react"
import AdminForm from "./form/AdminForm"
import AdminPanel from "./adminPanel/AdminPanel"
import AdminRequests from "./requests/AdminRequests"
import { Link } from "react-router-dom"
import adminApi from "./adminApi"
import './Admin.css'

const API_KEY = "/api/admin"

async function ApiMe() {
    return adminApi.get(API_KEY + '/me')
}

async function ApiRefresh() {
    return adminApi.post(
        API_KEY + '/refresh',
        null,
        { skipAuthRefresh: true }
    )
}

export default function Admin({ view = "products" }) {
    const [autorized, setAutorized] = useState("checking")

    useEffect(() => {
        async function checkAuthorization() {
            try {
                await ApiMe()
                setAutorized("autorized")
            } catch {
                try {
                    await ApiRefresh()
                    await ApiMe()
                    setAutorized("autorized")
                } catch {
                    setAutorized("unautorized")
                }
            }
        }

        checkAuthorization()
    }, [])

    if (autorized === 'autorized') {
        return (
            <main className="admin">
                <nav className="admin_nav">
                    <Link className={view === "products" ? "admin_navLink admin_navLink_active" : "admin_navLink"} to="/admin">
                        Продукты
                    </Link>
                    <Link className={view === "requests" ? "admin_navLink admin_navLink_active" : "admin_navLink"} to="/admin/requests">
                        Заявки
                    </Link>
                </nav>

                {view === "requests" ? (
                    <AdminRequests apiKey={API_KEY} />
                ) : (
                    <AdminPanel apiKey={API_KEY}></AdminPanel>
                )}
            </main>
        )
    }

    if (autorized === 'checking') {
        return (
            <main className="admin admin_login">
                <div className="adminLogin adminLogin_checking">
                    <p>Проверяем сессию...</p>
                </div>
            </main>
        )
    }

    return (
        <main className="admin admin_login">
            <AdminForm apiKey={API_KEY} onLoginSuccess={() => setAutorized('autorized')} />
        </main>
    )
}
